import RadioButtonQuest from "../../../../UI/RadioButtonQuest";
import charterhouseclaims from "../../../../../assets/UFC_DC_RF_V1/img/charterhouseclaims.png";
import { useState } from "react";

const Question118 = ({ clsName, onSelectAnswer, prevQuestion, btnDisable = false }) => {
  const [dropdown, setDropdown] = useState(false);

  const optionHandle = (e) => {
    onSelectAnswer(e);
  };

  // const handleBack = () => {
  //   prevQuestion("question118");
  // };

  return (
    <div className={`qswiper-slide slide-up-now ${clsName}`}>
      <h2 className="qs-title  ">
        While reviewing your case, we’ve identified a potential opportunity to pursue further claims for mis-sold car finance.
      </h2>
      <p className="fs-16">
        We believe a specialist claims partner may be able to support you with this, with the potential to recover £1,000s per car finance agreement*. If you choose to proceed, we can refer your details for further assessment.
      </p>
      <ul className="list-content mt-lg-0 mt-2 mb-0">
        <li>This will not reduce any compensation you may be entitled to</li>
        <li>
          You are free to choose a different solicitor, contact your lender directly, or refer your complaint to the Financial Ombudsman Service (FOS) yourself at no cost
        </li>
        <li>
          Any partner we refer to will act independently in handling your claim
        </li>
        <li>
          We may receive a referral fee if you proceed
        </li>
      </ul>
      <p className="fs-16 fw-bolder">
        Would you like us to refer your case for further review?
      </p>
      <div className="btn-option optinal-items two-options py-3 slide-up-now py-3">
        <div className="option_but animation-effct">
          <RadioButtonQuest
            key="q118_1"
            className="radio"
            labelName="Yes, Please Pursue"
            labelClassName="align-items-center endQuest"
            onClick={optionHandle}
            value="326"
            name="question118"
            id="326"
            dataQuestId={118}
            dataAnsId={326}
          />
        </div>
        <div className="option_but">
          <RadioButtonQuest
            key="q118_2"
            className="radio"
            labelName="No, Thank You"
            labelClassName="endQuest"
            onClick={optionHandle}
            value="327"
            name="question118"
            id="327"
            dataQuestId={118}
            dataAnsId={327}
          />
        </div>
      </div>
      <p className="fs-14">
        *Estimated outcomes may vary depending on individual circumstances.
      </p>
      {/* <div className="mt-2 mb-4 text-center">
        <div>
          {" "}
          <button
            className={`back-btn mainbckBtn bi bi-chevron-left ${btnDisable ? 'hide' : ''}`}
            type="button"
            onClick={handleBack}
            disabled={btnDisable}
          >
            Back
          </button>{" "}
        </div>
      </div> */}
      {dropdown && (
        <div className="side-toggle bg-white px-3 py-2 mb-3 rounded-3 shadow-sm slide-up-now">
          <p className="fs-14" style={{fontFamily: "Arial, Helvetica, sans-serif",fontStyle: "italic",fontSize: "13px"}}>
            Charterhouse Claims is authorised and regulated by the Financial Conduct Authority (FCA) 
            for regulated claims management services. 
            Our reference number is: 832999. 
            You can check this on Financial Services Register at  <a
              href="https://register.fca.org.uk" target="_blank">https://register.fca.org.uk. </a>
             Registered address: Charterhouse Claims LTD, Stafford Court, <a href="https://www.google.com/maps/place/Stafford+Court,+145+Washway+Rd,+Sale+M33+7PE,+UK/@53.4197778,-2.3312612,17z/data=!3m1!4b1!4m6!3m5!1s0x487bac5b656ccf03:0x4747ca65c9757d20!8m2!3d53.4197778!4d-2.3312612!16s%2Fg%2F1tcvntxf?entry=ttu&g_ep=EgoyMDI1MDYwOC4wIKXMDSoASAFQAw%3D%3D" target="_blank">145 Washway Road, Sale, Manchester, M33 7PE</a>.
          </p>
          <p className="fs-14 slide-up-now">
            *An FCA investigation revealed that the average customer
            on a £10,000 PCP agreement over four years has been
            overcharged by more than £1,100 (
            <a
              href="https://www.thesun.co.uk/money/30635528/car-finance-misselling-scandal-money-fca/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.thesun.co.uk/money/30635528/car-finance-misselling-scandal-money-fca/
            </a>
            )
          </p>
          <div className="fs-14 slide-up-now">
            ** If we are not successful in your claim, you do not
            pay anything. Clients have a 14 day "Cooling-Off" period
            during which time they may cancel at any time without
            charge. After this time, cancellation may result in the
            application of the Cancellation Fee. For more
            information
            <a
              className="btn btn-link fw-semibold ps-1 click-style btn-plese-click"
              onClick={() => setDropdown((prev) => !prev)}
            >
              please click here
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default Question118;
